import { useEffect, useState } from 'react';

import { FeatureVariant, GBFeatureKey } from '~/services/abTests/features';
import { growthBook } from '~/services/abTests/growthBook';

export const useGrowthbookFeatureValue = <K extends GBFeatureKey>(
  key: K,
): FeatureVariant<K> => {
  const [_, setRenderCount] = useState(0);

  useEffect(() => {
    if (!growthBook.instance || !growthBook.instance.setRenderer) return;

    growthBook.instance.setRenderer(() => {
      setRenderCount((prev) => prev + 1);
    });

    return (): void => {
      growthBook.instance?.setRenderer(() => {});
    };
  }, [growthBook]);

  return growthBook.getFeatureValue(key);
};
